export const getTabs = (CN: number = null) => {
    // CN (Credit Note), disable the credit note details and notes tabs when there is not credit note available
    const tabs = [
        { id: 'Lines', label: 'Lines' },
        { id: 'CreditNoteDetails', label: 'Credit Note Details', disabled: !CN },
        { id: 'Notes', label: 'Notes', disabled: !CN }
    ];

    return tabs;
};

export const CreditNoteLineDetailsCalculationFields = ['Quantity', 'Price', 'Discount', 'Reason', 'RestockingCharge'];

export const MODULES = {
    CREDIT_NOTES: 'creditnotes'
};
